<template>
	<layout-splash>
		<div class="h-full w-96">
			<ui-form class="flex flex-col" :loading="form.processing" @submit="submit">
				<div class="bg-green text-3xl px-6 py-4 text-white font-bold">
					Login
				</div>
				<div class="grid grid-cols-6 gap-y-4 gap-x-6 items-end py-4 px-6">
					<ui-input-group
						class="col-span-6"
						v-model="form.email"
						field="email"
						label="E-Mail"
						:form="form"
						:required="true"
					></ui-input-group>

					<ui-input-group
						class="col-span-6"
						v-model="form.password"
						field="password"
						label="Password"
						type="password"
						:form="form"
						:required="true"
					></ui-input-group>

					<ui-check-group
						class="col-span-6 flex mt-2"
						v-model="form.remember"
						field="consent.remember"
						:form="form"
						:required="false"
						>{{ __("Stay logged in on this device") }}</ui-check-group
					>
				</div>
				<div
					class="flex justify-end pt-4 pb-6 px-6 bg-gray-50 sm:rounded-b-xl justify-between items-center"
				>
					<inertia-link :href="$route('password.request')">{{
						__("Forgot Your Password?")
					}}</inertia-link>
					<ui-button native-type="submit" type="primary">Login</ui-button>
				</div>
			</ui-form>
		</div>
	</layout-splash>
</template>

<script>
export default {
	data() {
		return {
			form: this.$inertia.form({
				email: "",
				password: "",
				remember: true,
			}),
		};
	},
	methods: {
		submit() {
			this.form.email = this.$el.querySelector('input[type="text"]')?.value ?? "";
			this.form.password = this.$el.querySelector('input[type="password"]')?.value ?? "";

			this.form.post(this.$route("login"));
		},
	},
};
</script>
